<fs-chip
  *ngIf="show"
  [backgroundColor]="backgroundColor"
  [color]="color"
  [size]="size">
  {{ label }}
</fs-chip>
